import { render, staticRenderFns } from "./OrderTypeSwitcher.vue?vue&type=template&id=2e0632a9&scoped=true"
import script from "./OrderTypeSwitcher.vue?vue&type=script&lang=js"
export * from "./OrderTypeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeSwitcher.vue?vue&type=style&index=0&id=2e0632a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0632a9",
  null
  
)

export default component.exports